import React from "react";
import "./cta.css";

const CTA = () => {
  return (
    <div className="gpt3__cta section__margin section__padding">
      <div className="gpt3__cta-content">
        <p>Request Early Access to Get Started</p>
        <h3>Register Today & start exploring the endless possibilities.</h3>
      </div>
      <button className="gpt3__cta-btn">Get Started</button>
    </div>
  );
};

export default CTA;
